import { Helmet } from 'react-helmet';
import logo from '../logo.svg';

// Main Component for the Palm Ray Product Page
const PalmRayProductPage = () => {

    // The CSS is embedded here for convenience and to keep the component self-contained.
    const styles = `
      .palm-ray-page {
        font-family: 'Inter', sans-serif;
        background-color: #0c0c0c;
        color: #F4F4F4;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
      }
   
      .palm-ray-background-animation {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        overflow: hidden;
      }
   
      .palm-ray-circle {
        position: absolute;
        border-radius: 50%;
        filter: blur(140px);
        opacity: 0.7;
      }
   
      .pr-c1 {
        width: 500px; height: 500px;
        background: #5006ad; /* New Theme Color */
        top: 10%; left: 15%;
        animation: palmRayMove1 22s ease-in-out alternate infinite;
      }
   
      .pr-c2 {
        width: 600px; height: 600px;
        background: #5006ad; /* New Theme Color */
        bottom: 10%; right: 15%;
        animation: palmRayMove2 28s ease-in-out alternate-reverse infinite;
      }
       
      .pr-c3 {
        width: 400px; height: 400px;
        background: #a960ee; /* New Theme Accent Color */
        top: 40%; right: 20%;
        animation: palmRayMove3 25s ease-in-out alternate infinite;
      }
   
      @keyframes palmRayMove1 {
        from { transform: translate(0, 0) scale(1) rotate(0deg); }
        to { transform: translate(-10vw, 5vh) scale(1.1) rotate(30deg); }
      }
      @keyframes palmRayMove2 {
        from { transform: translate(0, 0) scale(1.1) rotate(0deg); }
        to { transform: translate(5vw, -10vh) scale(1) rotate(-40deg); }
      }
      @keyframes palmRayMove3 {
          from { transform: translate(0, 0) scale(1); }
          to { transform: translate(10vw, 10vh) scale(1.2); }
      }
   
      .palm-ray-wrapper {
        position: relative;
        z-index: 2;
        width: 100%;
        max-width: 1400px;
        padding: 1rem 2rem;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        margin: 0 auto;
        max-height: 100vh;
        overflow-y: auto;
        box-sizing: border-box;
      }
   
      .palm-ray-glass-box {
        background: rgba(30, 30, 35, 0.55);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border-radius: 24px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        padding: 2rem;
        box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.4);
      }
       
      .palm-ray-hero {
        text-align: center;
      }
   
      .palm-ray-hero h1 {
          font-size: 3rem;
          font-weight: 700;
          background: -webkit-linear-gradient(45deg, #5006ad, #a960ee);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 0.75rem;
      }
   
      .palm-ray-hero p {
          font-size: 1.1rem;
          max-width: 700px;
          margin: 0 auto;
          opacity: 0.9;
      }
   
      .palm-ray-features-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 1.5rem;
      }
       
      .palm-ray-feature-box {
        text-align: left;
        display: flex;
        flex-direction: column;
        background: rgba(45, 45, 50, 0.6);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        padding: 1.5rem;
      }
       
      .palm-ray-feature-box:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.5);
      }
       
      .palm-ray-feature-box .icon {
          margin-bottom: 1rem;
          width: 40px;
          height: 40px;
      }
       
      .palm-ray-feature-box h3 {
          font-size: 1.25rem;
          margin-bottom: 0.5rem;
          color: #fff;
      }

      .palm-ray-feature-box p {
          font-size: 0.9rem;
          line-height: 1.4;
      }
      
      .palm-ray-cta-box {
        text-align: center;
        padding: 2.5rem;
      }

      .palm-ray-cta-box h2 {
        font-size: 2rem;
        font-weight: 600;
        margin-bottom: 0.5rem;
      }
      
      .palm-ray-cta-btn {
        display: inline-block;
        margin-top: 1.5rem;
        padding: 0.8rem 2rem;
        border-radius: 12px;
        background: linear-gradient(45deg, #5006ad, #a960ee);
        color: white;
        text-decoration: none;
        font-weight: 600;
        font-size: 1.1rem;
        box-shadow: 0 4px 15px rgba(80, 6, 173, 0.5);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }

      .palm-ray-cta-btn:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(80, 6, 173, 0.7);
      }

      /* Floating Home Button */
      .floating-home-btn {
        position: fixed;
        bottom: 2rem;
        right: 2rem;
        z-index: 1000;
        background-color: rgba(80, 6, 173, 0.8); /* New Theme Color */
        color: white;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 20px rgba(0,0,0,0.4);
        border: 1px solid rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        transition: transform 0.3s ease, background-color 0.3s ease;
      }

      .floating-home-btn:hover {
        transform: scale(1.1);
        background-color: rgba(80, 6, 173, 1); /* New Theme Color */
      }

      .floating-home-btn svg {
        width: 28px;
        height: 28px;
      }
   
      /* Responsive adjustments */
      @media (max-width: 768px) {
          .palm-ray-page {
            position: relative;
            height: auto;
          }
          .palm-ray-wrapper {
            padding: 1.5rem;
            gap: 2rem;
            overflow-y: visible;
            max-height: none;
          }
          .palm-ray-hero h1 {
              font-size: 2.5rem;
          }
          .palm-ray-hero p {
              font-size: 1.1rem;
          }
          .floating-home-btn {
            width: 50px;
            height: 50px;
            bottom: 1rem;
            right: 1rem;
          }
      }
    `;
   
    return (
      <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Palm Ray™ - PalmDigitalz</title>
            <link rel="canonical" href="http://palmdigitalz.com/palm-ray" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="description" content="Palm Ray: Forward Engineering tool" />
            <meta name="keywords" content="palm ray, Palm Ray, mainframe modernization, app modernization, mainframe to microservices, COBOL to Python, PHP to Python, Java to Python, quality assurance" />
            <link rel="icon" href={logo}></link>
        </Helmet>

        <style>{styles}</style>
        <div className="palm-ray-page">
          {/* SVG Gradient for Icons */}
          <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
              <linearGradient id="palm-ray-icon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#5006ad' }} />
                <stop offset="100%" style={{ stopColor: '#a960ee' }} />
              </linearGradient>
            </defs>
          </svg>
   
          {/* Animated Background */}
          <div className="palm-ray-background-animation">
            <div className="palm-ray-circle pr-c1"></div>
            <div className="palm-ray-circle pr-c2"></div>
            <div className="palm-ray-circle pr-c3"></div>
          </div>
   
          {/* Page Content */}
          <div className="palm-ray-wrapper">
            <header className="palm-ray-hero palm-ray-glass-box">
              <h1>Palm Ray™</h1>
              <p>The forward engineering tool.</p>
            </header>
   
            <main>
              <div className="palm-ray-features-grid">
                 
                <div className="palm-ray-feature-box palm-ray-glass-box">
                  <svg className="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="url(#palm-ray-icon-gradient)">
                    <path d="M12 8l-2 2h4l-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M20 12l-2 2v4l2 2h-4l-2-2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 12l2 2v4l-2 2h4l2-2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 2l-2 2h4l-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M18 4l2 2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6 4l-2 2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <h3>Enterprise Grade Flask Microservices</h3>
                  <p>Generates robust, scalable, and secure microservices using Python and the Flask framework.</p>
                </div>
   
                <div className="palm-ray-feature-box palm-ray-glass-box">
                   <svg className="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="url(#palm-ray-icon-gradient)">
                     <path d="M12 8l-2 2h4l-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     <path d="M20 12l-2 2v4l2 2h-4l-2-2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     <path d="M4 12l2 2v4l-2 2h4l2-2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     <path d="M12 2l-2 2h4l-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     <path d="M18 4l2 2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     <path d="M6 4l-2 2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <h3>Enterprise Grade Spring Boot Microservices</h3>
                  <p>Automatically creates high-performance, production-ready microservices with Java and Spring Boot.</p>
                </div>

                <div className="palm-ray-feature-box palm-ray-glass-box">
                  <svg className="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="url(#palm-ray-icon-gradient)">
                    <path d="M12 20v-6m-4 0v6m8-12v12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 20h16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <h3>Quality Metrics</h3>
                  <p>Collects and analyzes key quality metrics to ensure generated code meets enterprise standards.</p>
                </div>
                
                <div className="palm-ray-feature-box palm-ray-glass-box">
                  <svg className="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="url(#palm-ray-icon-gradient)">
                    <polyline points="15 3 21 3 21 9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="9 21 3 21 3 15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="21" y1="3" x2="14" y2="10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="3" y1="21" x2="10" y2="14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <h3>Scalability</h3>
                  <p>Designs microservices with modern, scalable architectures ready for cloud-native deployment.</p>
                </div>

              </div>
            </main>
            <div className="palm-ray-cta-box palm-ray-glass-box">
                <h2>Try Palm Ray™ Lite</h2>
                <p>Experience the power of forward engineering. Convert a sample PHP code to a Flask microservice instantly.</p>
                <a href="https://ray.palmdigitalz.online" rel="noreferrer" target='_blank' className="palm-ray-cta-btn">Try PHP to Flask Converter</a>
            </div>
          </div>
          
          <a href="/" className="floating-home-btn" aria-label="Go to Homepage">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
             </svg>
          </a>

        </div>
      </>
    );
  };
   
  export default PalmRayProductPage;
